<template>
  <el-dialog title="设置封面" :visible.sync="dialogVisible" width="600px">
    <div class="up_box">
      <upload :showUrl="imageUrl" @success='onSuccessUpload' ref="upload"></upload>
    </div>
    <p class="frame_tit">默认封面选择</p>
    <div class="frame_box">
      <div class="f_item" v-for="(item,index) in frameImgList" :key="index">
        <img :src="item" alt="" srcset="" @click="uploadFrame(item)">
        <!-- <span>选择</span> -->
      </div>

    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios";
import upload from "./upload.vue";
export default {
  components: { upload },
  data() {
    return {
      dialogVisible: false,
      coverUrl: "",
      resourceId: "",
      imageUrl: "",
      frameImgList: [
        "/static/img/Frame1.png",
        "/static/img/Frame2.png",
        "/static/img/Frame3.png",
        "/static/img/Frame4.png",
      ],
    };
  },
  methods: {
    /**点击上传本地默认图片 */
    async uploadFrame(url) {
      let urlArr = url.match(/[^/]+/g);
      let fileName = urlArr[urlArr.length - 1];
      let res = await axios.get(url, {
        responseType: "arraybuffer",
      });
      let file = new File([res.data], fileName);
      let id = await this.$refs.upload.asyncMd5(file);
      let uploadTime = await this.$refs.upload.getDateTime();
      let formData = new FormData();
      formData.append("id", id);
      formData.append("uploadTime", uploadTime);
      formData.append("file", file);
      let result = await axios.post("/fileServer/upload", formData);
      this.onSuccessUpload(result.data);
    },
    reloadData() {
      this.coverUrl = "";
      this.resourceId = "";
      this.imageUrl = "";
    },
    init(data) {
      console.log(data);
      this.reloadData();
      this.resourceId = data.resourceId;
      this.coverUrl = data.coverUrl;
      this.imageUrl = data.coverUrl
        ? window.sessionStorage.getItem("fileJavaServerUrl") + data.coverUrl
        : "";
      this.dialogVisible = true;
    },
    onSuccessUpload(e) {
      console.log(e);
      this.coverUrl = e.result.coverUrl;
      this.imageUrl = this.coverUrl
        ? window.sessionStorage.getItem("fileJavaServerUrl") + this.coverUrl
        : "";
    },
    submit() {
      if (!this.coverUrl || !this.resourceId) {
        this.dialogVisible = false;
        return;
      }
      this.$ajax
        .post(
          "/server/third/resource/approval/set/cover",
          {
            resourceId: this.resourceId,
            coverUrl: this.coverUrl,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.$message({
            message: "设置成功",
            type: "success",
          });
          this.$emit("search");
          this.dialogVisible = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.avatar-uploader {
  text-align: center;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.up_box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.frame_tit {
  margin: 10px 20px;
}
.frame_box {
  display: flex;
  justify-content: space-around;
  .f_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    > img {
      width: 120px;
      height: auto;
      cursor: pointer;
    }
    > span {
      margin-top: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/audit/components/setCover.vue